import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { showMessage } from '../../utils/message';
import './Dashboard.css';

const Dashboard = () => {
  const [userInfo, setUserInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // 检查用户是否已登录
    const savedUserInfo = localStorage.getItem('userInfo');
    if (!savedUserInfo) {
      navigate('/login');
      return;
    }
    
    try {
      const parsedUserInfo = JSON.parse(savedUserInfo);
      setUserInfo(parsedUserInfo);
    } catch (error) {
      console.error('解析用户信息失败:', error);
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('userInfo');
    showMessage('已退出登录', 'success');
    navigate('/login');
  };

  if (!userInfo) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>加载中...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="logo-section">
            <h1>管理系统</h1>
          </div>
          
          <div className="user-section">
            <div className="user-info">
              <img 
                src={userInfo.image || '/default-avatar.png'} 
                alt="用户头像" 
                className="user-avatar"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFMkU4RjAiLz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSI4IiB5PSI4Ij4KPHBhdGggZD0iTTEyIDEyQzE0LjIwOTEgMTIgMTYgMTAuMjA5MSAxNiA4QzE2IDUuNzkwODYgMTQuMjA5MSA0IDEyIDRDOS43OTA4NiA0IDggNS43OTA4NiA4IDhDOCAxMC4yMDkxIDkuNzkwODYgMTIgMTIgMTJaIiBmaWxsPSIjNzE4MDk2Ii8+CjxwYXRoIGQ9Ik0xMiAxNEM5LjMzIDEzLjk5IDcuMDEgMTUuNjIgNiAxOEMxMC4wMSAyMCAxMy45OSAyMCAxOCAxOEMxNi45OSAxNS42MiAxNC42NyAxMy45OSAxMiAxNFoiIGZpbGw9IiM3MTgwOTYiLz4KPC9zdmc+Cjwvc3ZnPgo=';
                }}
              />
              <div className="user-details">
                <span className="username">欢迎，{userInfo.username}</span>
                <span className="user-role">管理员</span>
              </div>
            </div>
            
            <button onClick={handleLogout} className="logout-btn">
              退出登录
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-main">
        <div className="dashboard-content">
          <div className="welcome-section">
            <h2>欢迎回来！</h2>
            <p>您已成功登录系统，可以开始使用各项功能。</p>
          </div>

          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">📊</div>
              <div className="stat-content">
                <h3>数据统计</h3>
                <p className="stat-number">1,234</p>
                <p className="stat-label">总记录数</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-content">
                <h3>用户管理</h3>
                <p className="stat-number">567</p>
                <p className="stat-label">活跃用户</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">📈</div>
              <div className="stat-content">
                <h3>业务增长</h3>
                <p className="stat-number">+23%</p>
                <p className="stat-label">本月增长</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">⚡</div>
              <div className="stat-content">
                <h3>系统状态</h3>
                <p className="stat-number">99.9%</p>
                <p className="stat-label">运行时间</p>
              </div>
            </div>
          </div>

          <div className="quick-actions">
            <h3>快速操作</h3>
            <div className="actions-grid">
              <button className="action-btn">
                <span className="action-icon">📝</span>
                <span>创建新项目</span>
              </button>
              <button className="action-btn">
                <span className="action-icon">👤</span>
                <span>用户管理</span>
              </button>
              <button className="action-btn">
                <span className="action-icon">⚙️</span>
                <span>系统设置</span>
              </button>
              <button className="action-btn">
                <span className="action-icon">📊</span>
                <span>数据报表</span>
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;